<div class="call-history-search">
  <i class="material-icons">search</i>
  <input matInput
         class="call-history-search-input"
         [placeholder]="'SEARCH' | translate"
         (ccDebounceValueChange)="addFilter('phrase', $event.target.value)"/>
</div>
